import { Option } from '../../../../libs/types';

export const getInitialSelectedItem = (value: string | undefined, options: Option[]): Option | undefined =>
  options.find(option => option.value === value);
